export default "__VITE_ASSET__Cpxmi8sY__"